export default {
  title: 'Użycie usługi',
  type: 'object',
  properties: {
    price: {
      title: 'Cena początkowa',
      type: 'money',
      minimum: 0,
      fieldRequired: true
    },
    benefitId: {
      title: 'Id rabatu',
      type: 'number',
      fieldRequired: true
    },
    cardNumber: {
      title: 'Numer karty',
      type: 'string',
      fieldRequired: true,
      maxLength: 500
    },
    value: {
      title: 'Wysokość rabatu',
      type: 'number',
      fieldRequired: false
    },
    placeId: {
      title: 'Id obiektu',
      type: 'number',
      fieldRequired: true
    }
  }
};
